var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 63.116v-20l-11 20h11z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 32.116v-22h24.335c1.47 0 2.665 1.385 2.665 3.09v49.91H58.897",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.869 28.116H67v-6H51.869c-1.03 0-1.869 1.347-1.869 3s.83 3 1.869 3z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.88 41.116H67v-6h-7.12c-.485 0-.88 1.347-.88 3s.39 3 .88 3zM59.88 54.116H67v-6h-7.12c-.485 0-.88 1.347-.88 3s.39 3 .88 3z",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.767 70.116V56.519l-6.799 13.597h6.799z",
    fill: "#E1F8F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.806 54.881v2.822m20.763-5.643v18.056H8.806v-9.028",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.57 70.116v1a1 1 0 01-1-1h1zm-1-18.056a1 1 0 112 0h-2zm25.374 18.056h1a1 1 0 01-1 1v-1zm-1-18.056a1 1 0 112 0h-2zM28.57 70.116V52.06h2v18.056h-2zm25.375 1H29.57v-2h24.375v2zm-1-1V52.06h2v18.056h-2z",
    fill: "#376E66"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.376 37.246h21.282L28.282 48.354H7l14.376-11.108z",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.394 40.324h13.592l-3.633 2.708h-13.52l3.56-2.708z",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.46 36.507a1 1 0 00-1.349 1.477l1.348-1.477zm10.25 12.055a1 1 0 101.348-1.478l-1.348 1.478zM42.111 37.984L53.71 48.563l1.348-1.478-11.599-10.577-1.348 1.477z",
    fill: "#376E66"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "M15.851 55.008h7.597v6.906h-7.597z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.507 34.907c-3.24 0-5.868 2.51-5.868 5.604 0 .907.226 1.764.626 2.521H30.75c.4-.757.626-1.614.626-2.521 0-3.095-2.627-5.604-5.868-5.604z",
    fill: "#FFF7EE",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.735 41.824a.973.973 0 00-.855 1.106c.08.542.593.924 1.146.855l-.291-1.961zm1.188.678l-.453-.892-.004.002.457.89zm.74-1.317l.967-.27-.968.27zm-.799-.727l.214-.963h-.003l-.21.963zm-1.087.164l.283.954.008-.002-.291-.952zm-.915.002l-.395.904.007.003.388-.907zm-.612-.665l-.967.271.002.006.965-.277zm.74-1.316l.454.89-.454-.89zm1.165.68a.974.974 0 00.881-1.086 1.027 1.027 0 00-1.126-.88l.245 1.967zm-.275 3.481l.146.981h.006l.01-.002a2.35 2.35 0 00.123-.02 4.539 4.539 0 001.215-.372l-.914-1.779a2.522 2.522 0 01-.497.166 3.24 3.24 0 01-.23.045l-.008.001h.003l.146.98zm1.495.59c.393-.186.77-.493 1.024-.894.261-.411.42-.974.23-1.586l-1.934.543a.11.11 0 01-.004-.049c.002-.008.001.003-.015.029a.551.551 0 01-.205.173l.904 1.783zm1.255-2.48a2.114 2.114 0 00-1.552-1.419l-.427 1.926c.01.002.02.007.03.016.009.008.013.016.014.02l1.935-.543zm-1.555-1.42a2.295 2.295 0 00-.995.013c-.215.046-.505.139-.594.163l.582 1.904c.097-.027.212-.063.281-.083.083-.024.145-.041.198-.053.11-.023.129-.012.107-.017l.42-1.926zm-1.581.174a1.13 1.13 0 01-.235.044c-.04.002-.034-.004-.009.006l-.776 1.813c.633.268 1.245.136 1.586.045l-.566-1.908zm-.237.053a.09.09 0 01-.029-.021c-.01-.011-.012-.019-.012-.018l-1.931.554a2.123 2.123 0 001.182 1.292l.79-1.807zm-.039-.033c-.01-.03-.006-.035-.007-.021a.09.09 0 01-.01.033c0 .002.043-.071.243-.167l-.909-1.78c-.43.204-.843.509-1.1.954a1.88 1.88 0 00-.152 1.523l1.935-.542zm.227-.155a2.506 2.506 0 01.712-.21h0-.002l-.123-.983-.122-.983h-.001-.006a.44.44 0 00-.041.005 4.537 4.537 0 00-.4.072c-.242.056-.578.153-.927.318l.91 1.781z",
    fill: "#7E776E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.45 37.38l.428.835",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35 40.116l-3.579 3H18",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15 34.116c0-11.598 9.24-21 20.64-21 1.144 0 2.267.094 3.36.277",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 9.116L39 13.35l-3 3.765M18.447 32.942l-3.724 2.792L11 32.474",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgRefinance;